import { c as _c } from "react/compiler-runtime";
import { Box, Button, HStack, Icon, Spinner, Text, VStack } from '@chakra-ui/react';
import { UserSignupRegisterForm } from '@src/components/sco/Account/UserSignupRegisterForm';
import { DiagnosticColumns } from '@src/components/sco/PitchDeck/PitchDeckLandingDiagnostic/DiagnosticShell';
import { AccentHeading, Panel, REGISTER_PERKS } from '@src/components/sco/PitchDeck/PitchDeckLandingDiagnostic/shared';
import { useCommitPitchDeckDiagnostic } from '@src/components/sco/PitchDeck/PitchDeckLandingDiagnostic/useCommitPitchDeckDiagnostic';
import { PitchDeckAuditAdditionalFields } from '@src/components/sco/RequestFunnel/PitchDeckAudit/types';
import { useRequestFunnelContext } from '@src/components/sco/RequestFunnel/RequestFunnelContext';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import tracker from '@src/lib/tracker';
import React, { useEffect } from 'react';
import { LuCheck, LuChevronRight } from 'react-icons/lu';
export const RegisterStep: React.FC = () => {
  const $ = _c(29);
  const {
    currentUser,
    currentUserLoading
  } = useCurrentUser();
  const {
    isLoading,
    setStep,
    signupRequest,
    signupRequestId
  } = useRequestFunnelContext();
  const {
    busy,
    commitAndOpenDeck,
    error,
    isSaving,
    isSubmitting
  } = useCommitPitchDeckDiagnostic();
  const activeSignupRequestId = signupRequest.signupRequestId ?? signupRequestId;
  let t0;
  if ($[0] !== signupRequest.additionalFields) {
    t0 = signupRequest.additionalFields || {};
    $[0] = signupRequest.additionalFields;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const additionalFields = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useEffect(_temp, t1);
  let t2;
  let t3;
  if ($[3] !== additionalFields.deckStoredFileId || $[4] !== isLoading || $[5] !== setStep || $[6] !== signupRequest.pitchDeckUrl) {
    t2 = () => {
      if (isLoading) {
        return;
      }
      if (!signupRequest.pitchDeckUrl && !additionalFields.deckStoredFileId) {
        setStep("start");
      }
    };
    t3 = [additionalFields.deckStoredFileId, isLoading, setStep, signupRequest.pitchDeckUrl];
    $[3] = additionalFields.deckStoredFileId;
    $[4] = isLoading;
    $[5] = setStep;
    $[6] = signupRequest.pitchDeckUrl;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  useEffect(t2, t3);
  let t4;
  if ($[9] !== commitAndOpenDeck || $[10] !== currentUser?.isRegistered) {
    t4 = t5 => {
      const {
        skipAuth: t6
      } = t5 === undefined ? {} : t5;
      const skipAuth = t6 === undefined ? false : t6;
      if (!currentUser?.isRegistered && !skipAuth) {
        return;
      }
      commitAndOpenDeck();
    };
    $[9] = commitAndOpenDeck;
    $[10] = currentUser?.isRegistered;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const onUnlock = t4;
  let t5;
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <AccentHeading accent="deck audit" centered={true} line1="Get your full" />;
    t6 = <Text color="fg.muted" fontFamily="body" fontSize="sm" textAlign="center">Set up a free account and we’ll start analyzing every slide.</Text>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t5 = $[12];
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <>{t5}{t6}<VStack align="stretch" alignSelf="center" gap={2.5} marginTop={2}>{REGISTER_PERKS.map(_temp2)}</VStack></>;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== error) {
    t8 = error && <Text color="red.fg" fontSize="sm">{error}</Text>;
    $[15] = error;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== activeSignupRequestId || $[18] !== busy || $[19] !== currentUser || $[20] !== currentUserLoading || $[21] !== isSaving || $[22] !== isSubmitting || $[23] !== onUnlock || $[24] !== signupRequest.groupRequestTypeKey) {
    t9 = currentUserLoading ? <VStack gap={3} paddingY={6}><Spinner colorPalette="orange" size="lg" /></VStack> : currentUser?.isRegistered ? <VStack gap={3} paddingY={2}><Text color="fg.muted" fontSize="sm">Welcome back, {currentUser.displayName}!</Text><Button loading={busy} size="lg" variant="cta" width="full" onClick={() => onUnlock({
        skipAuth: true
      })}>Start My Audit<LuChevronRight /></Button></VStack> : <Box textAlign="left" width="full"><UserSignupRegisterForm focusTrigger={signupRequest.groupRequestTypeKey} hideAlreadyLoggedInAlert={true} hideFullName={true} inputProps={{
        size: "xl"
      }} signupRequestId={activeSignupRequestId} afterLoginTokenSent={_temp3} afterSuccess={async () => {
        tracker.emailSubmitted();
        tracker.funnelStep(6);
        onUnlock({
          skipAuth: true
        });
      }} containerProps={{
        background: "none",
        border: 0,
        boxShadow: "none",
        margin: 0,
        padding: 0
      }} socialLoginButtonsProps={{
        buttonLayout: "google-callout-grid",
        actionLabel: "Continue",
        buttonProps: {
          all: {
            size: "md",
            width: "full"
          }
        }
      }} submitButtonProps={{
        children: "Continue with Email",
        disabled: isSaving || !activeSignupRequestId,
        loading: isSubmitting || isSaving,
        variant: "cta",
        size: "lg",
        width: "full"
      }} /></Box>;
    $[17] = activeSignupRequestId;
    $[18] = busy;
    $[19] = currentUser;
    $[20] = currentUserLoading;
    $[21] = isSaving;
    $[22] = isSubmitting;
    $[23] = onUnlock;
    $[24] = signupRequest.groupRequestTypeKey;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t8 || $[27] !== t9) {
    t10 = <DiagnosticColumns left={t7} right={<><Panel>{t8}{t9}</Panel></>} />;
    $[26] = t8;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
};
function _temp() {
  tracker.funnelStep(5);
}
function _temp2(perk) {
  return <HStack key={perk} gap={2.5}><HStack bg="teal.500/18" borderRadius="full" boxSize="20px" color="teal.300" flexShrink={0} justify="center"><Icon asChild={true} boxSize={3}><LuCheck strokeWidth={2.5} /></Icon></HStack><Text fontFamily="body" fontSize="sm">{perk}</Text></HStack>;
}
async function _temp3() {
  tracker.emailSubmitted();
  tracker.funnelStep(6);
}